import {cloneDeep, find, isEmpty, sortBy, uniqBy} from 'lodash'
import VueCropper from 'vue-cropper'
import constants from '@/libs/constant/constants'
import {message, errorHandler, logout, loader, urlValidation, getImageUrl, onError, beforeAvatarUpload} from '@/libs/helper'
import {
    uploadImage,
    updateAuthor,
    updatePublisher,
    updateUserProfile,
    getImageUploadURL,
    updatePublication
} from '@/libs/api/api'

export default{
    name: 'ManageAuthorImage',
    props:{
        stepBack: {
            type: Function,
            default: () =>{}
        },
        stepForward: {
            type: Function,
            default: () =>{}
        },
        setClaimTo: {
            type: Function,
            default: () =>{}
        },
        cancel: {
            type: Function,
            default: () =>{}
        },
        displaySocialMedia: {
            type: Boolean,
            default: () => true
        },
        displayImageSection: {
            type: Boolean,
            default: () => true
        },
        showButtons: {
            type: Boolean,
            default: ()=> true
        },
        updateSource: {
            type: Function,
            default: () => {}
        },
        claimTo: {
            type: Object,
            default: () => {}
        },
        disabled: {
            type: Boolean,
            default: ()=> false
        },
        isEdit: {
            type: Boolean,
            default: ()=> false
        },
        module: {
            type: String,
            default: () => constants.AUTHOR.key
        },
        isAdmin: {
            type: Boolean,
            default: false
        },
        adminEditButtons: {
            type: Boolean,
            default: false
        },
        isAdd: {
            type: Boolean,
            default: false
        },
        isOrganisation: {
            type: Boolean,
            default: false
        }
    },
    beforeMount(){
        this.imageAvatar = this.claimTo.avatar_image || null
        this.imagePreview = this.claimTo.imagePreview || null
    },
    components: {
        VueCropper
    },
    watch: {
        claimTo (newValue) {
            this.imageAvatar = newValue.avatar_image || null,
            this.imagePreview = newValue.imagePreview || null,
            this.imageName = newValue.imageName || ''
            this.addedPlatform = newValue && newValue.social_media || [],
            this.selectedPlatform = newValue && newValue.social_media || []
        }
    },
    data(){
        return {
            beforeAvatarUpload,
            getImageUrl: getImageUrl,
            onError: onError,
            imageAvatar: this.claimTo.avatar_image || null,
            imageBlobData: this.claimTo && this.claimTo.imageBlobData || null,
            imagePreview: this.claimTo && this.claimTo.imagePreview || null,
            imageName: this.claimTo && this.claimTo.imageName || '',
            visibleCropDialog: false,
            imageCropperConfig: {
                img: '',
                autoCrop: true,
                autoCropWidth: 220,
                autoCropHeight: 220,
                fixedBox: true,
                canMoveBox: true,
                canMove: true

    },
            uploadImageData:{},
            file: {},
            platforms: [{type:'FACEBOOK', url: ''},{type:'LINKEDIN', url: ''},{type:'TWITTER', url: ''},{type: 'PARLER', url: ''}],
            addedPlatform: this.claimTo && this.claimTo.social_media || [],
            selectedPlatform: this.claimTo && this.claimTo.social_media || []
        }
    },
    methods: {
        /*
        * selectImageToUpload selects the image on the cropping window.
        * */
        selectImageToUpload (e, num) {
            let file = e.target.files[0]
            this.imageName = e.target.files[0].name
            let reader = new FileReader()
            reader.onload = (e) => {
                let data
                if (typeof e.target.result === 'object') {
                    data = window.URL.createObjectURL(new Blob([e.target.result]))
                } else {
                    data = e.target.result
                }
                if (num === 1) {
                    this.imageCropperConfig.img = data
                }
                this.visibleCropDialog =  !this.visibleCropDialog;
            }
            reader.readAsArrayBuffer(file)
        },
        setImage: async function(){
            this.$refs.imageCropper.getCropData((datafile) => {
                this.imageAvatar = null
                this.imagePreview = datafile
            })
            this.visibleCropDialog =  !this.visibleCropDialog;

            this.imageBlobData = await this.createBlobObject()
        },
        /*
        * uploadImage() uploads the image to the s3 server
        * */
        uploadImage: async function(module, file){
            loader(this, true);
            getImageUploadURL({imageName: this.imageName})
                .then((uploadUrls)=>{
                    this.uploadImageData = uploadUrls;
                    return this.createBlobObject(uploadUrls, file.file)
                }).then((image)=>{
                    return uploadImage(image)
                }).then(()=>{
                    let body = {
                        avatar_image: this.uploadImageData.fileKey
                    }
                    if(this.isAdmin) body.admin_request = true
                    if(module === constants.AUTHOR.key){
                        return updateAuthor(body, this.claimTo._id)
                    }else if(module === constants.PUBLISHER.key){
                        return updatePublisher(body, this.claimTo._id)
                    }else if(module === constants.PUBLICATION.key){
                        return updatePublication(body, this.claimTo._id)
                    } else if(module === 'ADMIN') {
                        body.user_id = this.claimTo._id
                        return updateUserProfile(body)
                    }
                }).then(()=>{
                    loader(this, false);
                    let claimTo = cloneDeep(this.claimTo)
                    claimTo.avatar_image = this.uploadImageData.fileKey
                    this.updateSource('IMAGE', claimTo)
                    this.imageAvatar = this.uploadImageData.fileKey
                    if(module === constants.AUTHOR.key){
                        this.$store.dispatch('updateRegisteredAuthor', claimTo)
                    }else if(module === constants.PUBLISHER.key){
                        this.$store.dispatch('updateRegisteredPublisher', claimTo)
                    }else if(module === constants.PUBLICATION.key){
                        this.$store.dispatch('updateRegisteredPublication', claimTo)
                    }
                    message(this, constants.messageType.SUCCESS, ('Updated Successfully'));
                    this.visibleCropDialog = !this.visibleCropDialog;
                }).catch((error)=> {
                    loader(this, false);
                    message(this, constants.messageType.ERROR, errorHandler(error, logout.bind(this, this)))
                });
        },
        /*
        * createBlobObject() creates and returns the binary image format to upload
        * */
        createBlobObject(uploadUrl, file){
            return new Promise((resolve) => {
                let reader = new FileReader(file)
                reader.addEventListener("loadend",function (data) {
                    return resolve({imageData: data.target.result, uploadUrl })
                });
                reader.readAsArrayBuffer(file);
            })
        },
        /*
        * update the user information.
        * */
        update(body){
            loader(this, true);
            updateUserProfile(body)
                .then((response)=> {
                    if (response.id) {
                        message(this, constants.messageType.SUCCESS, ('Updated Successfully'));
                        this.$store.dispatch(constants.dispatch.SET_USER_INFORMATION_TO_STORE, response);
                    }
                    loader(this, false);
                })
                .catch((error)=> {
                    message(this, constants.messageType.ERROR, errorHandler(error, logout.bind(this, this)))
                    loader(this, false);
                })
        },
        editSocialPlatform(module, platform, index, isRemove){

            if(!isRemove && !this.socialMediaUrlValidation(platform)){
                message(this, constants.messageType.ERROR, `${('Please enter valid')} ${platform.type.toLowerCase()} url`)
                return
            }

            loader(this, true);
            let addedPlatform = cloneDeep(this.addedPlatform)

            if(isRemove){
                addedPlatform = addedPlatform.filter(pf => pf.type !== platform.type)
            } else {
                addedPlatform[index] = platform
            }

            addedPlatform.map((p, index) => {
                if(p._id){
                    delete addedPlatform[index]._id
                }
                if(p.createdAt){
                    delete addedPlatform[index].createdAt
                }
                if(p.updatedAt){
                    delete addedPlatform[index].updatedAt
                }
            })
            addedPlatform = addedPlatform.filter(pf => pf.url && pf.url !== '')
            if(module === constants.AUTHOR.key){
                updateAuthor({social_media: addedPlatform}, this.claimTo._id)
                    .then((response)=> {
                        if (response.success) {
                            this.addedPlatform = addedPlatform
                            if(isRemove){
                                this.selectedPlatform = this.selectedPlatform.filter(p => p.type !== platform.type)
                            }
                            message(this, constants.messageType.SUCCESS, ('Updated Successfully'));
                            let claimTo = cloneDeep(this.claimTo)
                            claimTo.social_media = cloneDeep(this.addedPlatform)
                            this.updateSource('SOCIAL_MEDIA', claimTo)
                            this.setClaimTo(cloneDeep(claimTo))
                            this.$store.dispatch('updateRegisteredAuthor', claimTo)
                        }
                        loader(this, false);
                    })
                    .catch((error)=> {
                        message(this, constants.messageType.ERROR, errorHandler(error, logout.bind(this, this)))
                        loader(this, false);
                    })
            }else if(module === constants.PUBLISHER.key){
                updatePublisher({social_media: addedPlatform}, this.claimTo._id)
                    .then((response)=> {
                        if (response.success) {
                            this.addedPlatform = addedPlatform
                            if(isRemove){
                                this.selectedPlatform = this.selectedPlatform.filter(p => p.type !== platform.type)
                            }
                            message(this, constants.messageType.SUCCESS, ('Updated Successfully'));
                            let claimTo = cloneDeep(this.claimTo)
                            claimTo.social_media = cloneDeep(this.addedPlatform)
                            this.updateSource('SOCIAL_MEDIA', claimTo)
                            this.setClaimTo(cloneDeep(claimTo))
                            this.$store.dispatch('updateRegisteredPublisher', claimTo)
                        }
                        loader(this, false);
                    })
                    .catch((error)=> {
                        message(this, constants.messageType.ERROR, errorHandler(error, logout.bind(this, this)))
                        loader(this, false);
                    })
            }else if(module === constants.PUBLICATION.key){
                updatePublication({social_media: addedPlatform}, this.claimTo._id)
                    .then((response)=> {
                        if (response.success) {
                            this.addedPlatform = addedPlatform
                            if(isRemove){
                                this.selectedPlatform = this.selectedPlatform.filter(p => p.type !== platform.type)
                            }
                            message(this, constants.messageType.SUCCESS, ('Updated Successfully'));
                            let claimTo = cloneDeep(this.claimTo)
                            claimTo.social_media = cloneDeep(this.addedPlatform)
                            this.updateSource('SOCIAL_MEDIA', claimTo)
                            this.setClaimTo(cloneDeep(claimTo))
                            this.$store.dispatch('updateRegisteredPublication', claimTo)
                        }
                        loader(this, false);
                    })
                    .catch((error)=> {
                        message(this, constants.messageType.ERROR, errorHandler(error, logout.bind(this, this)))
                        loader(this, false);
                    })
            }
        },
        updateSocialPlatform(platform, index, isRemove){
            if(!isRemove && !this.socialMediaUrlValidation(platform)){
                message(this, constants.messageType.ERROR, `${('Please enter valid')} ${platform.type.toLowerCase()} url`)
                return
            }

            let addedPlatform = cloneDeep(this.addedPlatform)

            if(isRemove){
                addedPlatform = addedPlatform.filter(pf => pf.type !== platform.type)
            } else {
                addedPlatform[index] = platform
            }   
            this.addedPlatform = addedPlatform

            let claimTo = this.claimTo
            claimTo.social_media = this.addedPlatform.filter(pf => pf && pf.url && pf.url !== '')

            this.selectedPlatform = claimTo.social_media
        },
        selectPlatformToAdd(plateform){
            let selectedPlatform = cloneDeep(this.selectedPlatform)
            if (find(selectedPlatform, plateform)) {
                if (selectedPlatform.length !== 1) {
                    selectedPlatform = selectedPlatform.filter(f => f !== plateform.type)
                }
            } else {
                selectedPlatform.push(plateform)
            }
            this.selectedPlatform = cloneDeep(selectedPlatform)
        },
        addPlatform(){
            if(isEmpty(this.addedPlatform)){
                this.addedPlatform = this.selectedPlatform
            }else{
                this.addedPlatform = sortBy(uniqBy(this.addedPlatform.concat(this.selectedPlatform), 'type'), 'type')
            }
        },
        isDisabled (platform) {
            let socialPlatform = this.claimTo.social_media
            return find(socialPlatform, platform) ? true : false
        },
        isChecked (platform) {
            let addedPlatform = this.selectedPlatform
            return addedPlatform.filter(p => p.type === platform.type).length > 0
        },
        /*
        * deletes the Avatar image.
        * */
        deleteAvatar(){
            loader(this, true);
            updateUserProfile({avatar_image:""})
                .then((response)=> {
                    if (response.id) {
                        message(this, constants.messageType.SUCCESS, ('Updated Successfully'));
                        this.$store.dispatch(constants.dispatch.SET_USER_INFORMATION_TO_STORE, response);
                    }
                    loader(this, false);
                })
                .catch((error)=> {
                    message(this, constants.messageType.ERROR, errorHandler(error, logout.bind(this, this)))
                    loader(this, false);
                })
        },
        submitForm (formName, isTrue) {
            this.$refs[formName].validate((valid) => {
                if (!valid) {
                    return
                }

                this.addedPlatform =
                    this.addedPlatform.filter(sm =>
                        sm.type.toLowerCase() === 'facebook' && sm.url.match(/facebook.com/g) ||
                        sm.type.toLowerCase() === 'linkedin' && sm.url.match(/linkedin.com/g) ||
                        sm.type.toLowerCase() === 'twitter' && sm.url.match(/twitter.com/g)
                    )

                let claimTo = this.claimTo
                claimTo.avatar_image = this.imageAvatar
                claimTo.imagePreview = this.imagePreview
                claimTo.social_media = this.addedPlatform
                claimTo.imageName = this.imageName
                claimTo.imageBlobData = this.imageBlobData
                if (isTrue === undefined) this.stepForward()
                else if (isTrue) this.stepBack()
            })
        },
        socialMediaUrlValidation(platform){
            if(platform.type.toLowerCase() === 'facebook' && (!urlValidation(platform.url) || !platform.url.match(/facebook.com/g))){
                return false
            }

            if(platform.type.toLowerCase() === 'linkedin' && (!urlValidation(platform.url) || !platform.url.match(/linkedin.com/g))){
                return false
            }

            if(platform.type.toLowerCase() === 'twitter' && (!urlValidation(platform.url) || !platform.url.match(/http(?:s)?:\/\/(?:www\.)?twitter\.com\/([a-zA-Z0-9_]+)/g))){
                return false
            }

            if(platform.type.toLowerCase() === 'parler' && (!urlValidation(platform.url) || !platform.url.match(/http(?:s)?:\/\/(?:www\.)?parler\.com\/([a-zA-Z0-9_]+)/g))){
                return false
            }

            return true
        },
        getPhotoLabel(module){
            switch (module){
                case constants.AUTHOR.key:
                    return 'Author Photo'
                case constants.PUBLISHER.key:
                    return 'Publisher Logo'
                case constants.PUBLICATION.key:
                    return 'Publication Logo'
                case 'ADMIN':
                    return 'User Photo'
            }
        },
        getPhotoDescriptionLabel(module){
            switch (module){
                case constants.AUTHOR.key:
                    return 'Select the photo of the Author (png, jpeg)'
                case constants.PUBLISHER.key:
                    return 'Select the official logo of the Publisher (png, jpeg)'
                case constants.PUBLICATION.key:
                    return 'Select the official logo of the Publication (png, jpeg)'
                case 'ADMIN': 
                    return 'Select the official logo of the Publication (png, jpeg)'
            }
        },
        getUploadPhotoButtonLabel(module){
            switch (module){
                case constants.AUTHOR.key:
                    return 'Upload photo'
                case constants.PUBLISHER.key:
                    return 'Upload Logo'
                case constants.PUBLICATION.key:
                    return 'Upload Logo'
                case 'ADMIN':
                    return 'Upload Logo'    
            }
        },
        handleAvatarSuccess () {
        },
        uploadFile:async function (file) {
            this.imageName = file.file.name
            this.file = file
            this.imageBlobData = await this.createBlobObject({}, file.file)
            this.imagePreview = window.URL.createObjectURL(file.file)
            let claimTo = this.claimTo
            claimTo.avatar_image = this.imageAvatar
            claimTo.imagePreview = this.imagePreview
            claimTo.imageName = this.imageName
            claimTo.imageBlobData = this.imageBlobData
            if (this.isEdit) {
                this.uploadImage(this.module, file)
            }       
        },
        backButton () {
            this.submitForm('manageAuthorImage', true)
        }
    }
}